// extracted by mini-css-extract-plugin
export default {"testTable":"SacredArmourOfAntiriad_testTable__A72wL"};